import { language } from '../utils/language';

const RESPONSE_MAPPING = {
  SUCCESS: language.success,
  FAIL: language.system_error,
  SERVER_ERROR: language.error.server_error,

  DATA_INVALID: language.error.data_invalid,

  // unit group
  UNIT_GROUP_CANNOT_DELETE: language.error.unit_group_cannot_delete,
  UNIT_GROUP_TEMPLATE_PAYLOAD_MALFORMED: language.error.the_content_contains_invalid_keywords,
  UNIT_GROUP_LOCK_DATE_ACTIVE_MISSING: language.error.unit_group_lock_date_active_missing,
  UNIT_GROUP_LOCK_DATE_INVALID: language.error.unit_group_lock_date_invalid,
  UNIT_GROUP_LOCK_DATE_EXISTED: language.error.unit_group_lock_date_existed,
  UNIT_GROUP_LOCK_DATE_DUPLICATE: language.error.unit_group_lock_date_duplicate,
  UNIT_GROUP_PROJECT_CODE_INVALID: language.error.the_project_code_is_not_valid,
  BANK_ACCOUNT_SERVICE_DUPLICATE: 'Một dịch vụ chỉ được gán cho một tài khoản ngân hàng.',
  BANK_ACCOUNT_FUND_INVALID: 'Quỹ không thuộc tòa nhà này.',

  // unit
  UNIT_DELETE_ERROR: language.error.apartment_can_not_delete,
  UNIT_AREA_VALIDATE: language.error.apartment_area_validate,
  UNIT_NAME_UNIQUE: language.error.unit_name_unique,
  DELETE_APARTMENT_ERROR: language.error.apartment_can_not_delete,
  UNIT_INVALID_DATA: language.error.data_invalid,

  // user
  USER_EMAIL_UNIQUE: language.error.user_email_unique,
  USER_EMAIL_NOT_VERIFY: language.error.user_email_not_verify,
  USER_NOT_ACTIVE: language.error.user_not_active,
  USER_LOGIN_FAILED: language.error.login_unsuccessful,
  USER_PHONE_UNIQUE: language.error.resident_phone_unique, // temp error
  USER_EMAIL_NOT_FOUND: language.user_email_not_found,
  USER_WRONG_USERNAME_OR_PASSWORD: language.user_wrong_username_or_password,

  // floor
  FLOOR_DELETE_ERROR: language.error.floor_can_not_delete,

  // department
  DEPARTMENT_NAME_UNIQUE: language.error.department_name_unique,
  DEPARTMENT_DELETE_ERROR: language.error.department_delete_error,

  // employee
  EMPLOYEE_POSITION_MISSING: language.error.employee_position_missing,
  EMPLOYEE_DEPARTMENT_MISSING: language.error.employee_department_missing,
  EMPLOYEE_EMAIL_UNIQUE: language.error.employee_email_unique,
  EMPLOYEE_PHONE_UNIQUE: language.error.employee_phone_unique,
  EMPLOYEE_NOT_HAVE_PERMISSION: language.error.employee_not_have_permission,
  EMPLOYEE_ALREADY_EXISTS: language.error.employee_already_exists,

  // resident
  RESIDENT_UNIT_MISSING: language.error.resident_unit_missing,
  RESIDENT_IDENTIFIER_UNIQUE: language.error.resident_identifier_unique,
  RESIDENT_EMAIL_UNIQUE: language.error.resident_email_unique,
  RESIDENT_PHONE_UNIQUE: language.error.resident_phone_unique,
  RESIDENT_VISA_UNIQUE: language.error.resident_visa_unique,
  RESIDENT_ROLE_UNIQUE: language.error.resident_role_unique,
  RESIDENT_ACTIVE_ERROR: language.error.resident_active_error,
  RESIDENT_POLICY_ALREADY_CONFIRMED_ERROR: language.resident_policy_already_confirmed_error,
  RESIDENT_PHONE_MISSING: language.resident_phone_missing,

  // contract
  CONTRACT_TARGET_MISSING: language.error.contract_target_missing,
  CONTRACT_CONTRACT_TEMPLATE_MISSING: language.error.contract_contract_template_missing,
  CONTRACT_CARD_ID_EXISTED: language.contract_card_id_existed,
  CONTRACT_CAN_NOT_IMPORT_COLUMN_REGISTRATION_PLATE_RAW: language.contract_can_not_import_column_registration_plate_raw,

  // label
  LABEL_TITLE_UNIQUE: language.error.label_title_unique,
  GROUPLABEL_ABBREVIATE_TITLE_UNIQUE: language.status.invalid_abbreviate_title_label,
  LABEL_ABBREVIATE_TITLE_UNIQUE: language.status.invalid_abbreviate_title_label,
  LABEL_DELETE_ERROR: language.can_not_delete_using_label,
  LABEL_GROUP_DELETE_ERROR: language.can_not_delete_group_contain_child_or_label,

  // fund
  FUND_NAME_UNIQUE: language.error.fund_name_unique,
  FUND_DELETE_ERROR: language.error.delete_fund_failed,
  FUND_IS_NOT_EXIST_IN_UNIT_GROUP: language.error.fund_is_not_exist_in_unit_group,

  // upload
  UPLOAD_EXCEL_DATA_EMPTY: language.error.upload_excel_data_empty,
  UPLOAD_FILE_NOT_FOUND: language.error.upload_file_not_found,
  UPLOAD_FILE_TYPE_ERROR: language.error.upload_file_type_error,

  // position
  POSITION_NAME_UNIQUE: language.error.position_name_unique,
  POSITION_DELETE_ERROR: language.error.position_delete_error,

  // service
  SERVICE_NAME_UNIQUE: language.error.service_name_unique,
  SERVICE_IDENTIFIER_UNIQUE: language.error.service_identifier_unique,
  SERVICE_HAS_CONTRACTS: language.error.service_has_contracts,

  // receipt
  RECEIPT_CANCEL_ERROR: language.error.money_in_apartment_account_not_enough_to_cancel_receipt,
  RECEIPT_HAS_BILL_IS_ADJUSTED_DOWN: language.error.receipt_has_bill_is_adjusted_down,
  RECEIPT_LOCKED: language.receipt_locked,
  DEBT_BILL_IN_OTHER_RECEIPT: language.receipts_contain_partial_bills_linked_to_other_receipts,

  // pay slip
  PAYSLIP_CREATE_ERROR: language.error.total_payment_greater_than_unit_account_balance,
  TOTAL_PAYMENT_EXCEEDING: language.error.maximum_amount_can_be_spent_unit_account_balance,

  // announcement
  ANNOUNCEMENT_CONTENT_VALIDATE: language.error.announcement_content_not_null,
  ANNOUNCEMENT_SENDTYPES_VALIDATE: language.error.announcement_send_type_not_null,

  // payment
  BILL_HAVE_BEEN_PAID: language.error.bill_have_been_paid,
  BILL_HAVE_BEEN_REMOVED: language.error.bill_have_been_removed,
  BILL_INCURRED_CREATED_FOR_INVALID: language.error.bill_incurred_created_for_invalid,

  // request
  TASK_DUEDATE_VALIDATE: language.error.request_task_due_date_validate,
  REQUEST_COMPLETED_FAIL: language.error.request_change_progress_complete_failure,
  REQUEST_DUEDATE_VALIDATE: language.error.request_task_due_date_validate,

  INTERNET_NOT_CONNECTED: language.error.internet_not_connected,
  USER_EMAIL_VALIDATE: language.error.user_email_validate,

  // Adjust bill down
  AMOUNT_OF_MONEY_NEED_ADJUST_NOT_LESS_THAN_ZERO: language.error.amount_of_money_need_adjust_not_less_than_zero,
  ORIGIN_BILL_TOTAL_PAYMENT_LTE_AMOUNT_MONEY_NEED_ADJUST: language.error.origin_bill_total_payment_lte_amount_money_need_adjust,
  AMOUNT_OF_MONEY_OF_UNIT_ACCOUNTS_LTE_THE_DIFFERENCE_BETWEEN_THE_TWO_ADJUSTMENTS:
    language.error.amount_of_money_of_unit_accounts_lte_the_difference_between_the_two_adjustments,
  UNITACCOUNT_BALANCE_VALIDATE: language.label.unit_account_balance_validate,

  BILL_PARTIAL_PAID: language.error.bill_partial_paid,
  BILL_PAID: language.error.bill_paid_not_cancel,
  BILL_CANCELLED: language.error.bill_not_cancel,
  BILL_SYNC_E_INVOICE: language.error.bill_sync_billing_cannot_cancel,
  BILL_ALREADY_SYNC_BILLING: language.error.bill_sync_billing_cannot_cancel,
  EXISTS_ADJUST_BILL_HAVE_NOT_CANCELLED_YET: language.error.exists_adjust_bill_have_not_cancelled_yet,
  AMOUNT_OF_MONEY_OF_UNIT_ACCOUNTS_LTE_AMOUNT_OF_MONEY_OF_BILL: language.error.amount_of_money_of_unit_accounts_lte_amount_of_money_of_bill,
  // Deparment
  DEPARTMENT_ADMIN_ERROR: language.error.cannot_update_or_delete_on_admin_department,

  // Position
  POSITION_ADMIN_ERROR: language.error.cannot_update_or_delete_on_admin_position,
  POSITION_ADMIN_CANNOT_EMPTY: language.error.admin_position_must_exist_at_least_1_employee,

  // amenities
  UTILITY_LIMIT_ORDER_PER_TIME_TYPE_INVALID: language.utility_limit_order_per_time_type_invalid,
  UTILITY_LIMIT_ORDER_PER_TIME_INVALID: language.utility_limit_order_per_time_invalid,
  UTILITY_NAME_REQUIRED: language.utility_name_required,
  UTILITY_NAME_INVALID_LENGTH: language.utility_name_invalid_length,
  UTILITY_PAYMENT_METHOD_INVALID: language.utility_payment_method_invalid,
  UTILITY_PAY_BEFORE_TIME_INVALID: language.utility_pay_before_time_invalid,
  UTILITY_PAY_BEFORE_TIME_TYPE_INVALID: language.utility_pay_before_time_type_invalid,
  FORMULA_TYPE_INVALID: language.formula_type_invalid,
  UTILITY_CODE_REQUIRED: language.utility_code_required,
  UTILITY_CODE_UNIQUE: language.utility_code_unique,
  UTILITY_PHOTO_REQUIRED: language.utility_photo_required,
  UTILITY_PRIORITY_IN_APP_REQUIRED: language.utility_priority_in_app_required,
  UTILITY_PRIORITY_IN_APP_INVALID: language.utility_priority_in_app_invalid,
  UTILITY_DESCRIPTION_INVALID: language.utility_description_invalid,
  UTILITY_LOCATION_INVALID: language.utility_location_invalid,
  UTILITY_PRE_ORDER_TIME_INVALID: language.utility_pre_order_time_invalid,
  UTILITY_LIMIT_ORDER_PER_USAGE_INVALID: language.utility_limit_order_per_usage_invalid,
  UTILITY_LIMIT_ORDER_PER_USAGE_TYPE_INVALID: language.utility_limit_order_per_usage_type_invalid,
  UTILITY_DEPOSIT_INVALID: language.utility_deposit_invalid,
  UTILITY_TYPE_INVALID: language.utility_type_invalid,
  UTILITY_FORMULAS_INVALID: language.utility_formulas_invalid,
  UTILITY_FORMULAS_FORMAT_INVALID: language.utility_formulas_format_invalid,
  UTILITY_IS_HAVING_ORDERS_TO_PROCESS_ERROR: language.utility_is_having_orders_to_process,
  UTILITY_BOOKING_CAN_NOT_APPROVE: language.utility_booking_can_not_approve,
  UTILITY_OVER_LIMIT_ORDER_PER_TIME: language.utility_over_limit_order_per_time,
  UTILITY_BOOKING_CAN_NOT_SYNC_BILLING: language.utility_booking_cannot_sync_billing,
  INVOICE_BUYER_ADDRESS_REQUIRED_WHEN_HAS_TAX_CODE: language.invoice_buyer_address_required_when_has_tax_code,
  INVOICE_BUYER_NOT_FOUND: language.error.invoice_buyer_not_found,

  UTILITY_BOOKING_ALREADY_SYNCED_TO_BILLING: language.utility_booking_already_synced_to_billing,
  UTILITY_BILLING_CONFIG_NOT_FOUND: language.utility_billing_config_not_found,
  UTILITY_BILLING_SURCHARGE_CONFIG_MISSING: language.utility_billing_surcharge_config_missing,
  UTILITY_BOOKING_UTILITY_CONFIG_INVALID: language.utility_booking_utility_config_invalid,
  UTILITY_BOOKING_UNIT_EXCLUDED: language.utility_booking_unit_excluded,
  UTILITY_BOOKING_CANCELLED_CANNOT_SYNC: language.utility_booking_cancelled_cannot_sync,
  UTILITY_BOOKING_ZERO_REVENUE_CANNOT_SYNC: language.utility_booking_zero_revenue_cannot_sync,
  UTILITY_BOOKING_VAT_CONFIG_MISSING: language.utility_booking_vat_config_missing,
  UTILITY_BOOKING_CAN_NOT_UPDATE: language.utility_booking_can_not_update,

  // report stored
  SAVEDREPORT_NAME_UNIQUE: language.error.report_exist,

  // Adjust bill
  ORIGIN_BILL_NOT_FOUND: language.error.no_original_bill_found,
  ORIGIN_BILL_CAN_NOT_ADJUST: language.error.unable_to_update_an_adjustable_voucher_for_this_invoice,
  ORIGIN_BILL_CANCELLED: language.error.the_original_bill_has_been_canceled,
  ADJUST_BILL_NOT_EXISTS: language.error.bill_does_not_exist,
  ADJUST_BILL_CAN_NOT_UPDATE: language.error.unable_to_update_an_adjustable_voucher_for_this_invoice,
  ADJUST_BILL_PAID: language.error.bill_paid,
  ADJUST_BILL_CANCELLED: language.error.bill_has_been_canceled,
  ORIGIN_BILL_ADJUSTED: language.error.only_make_adjustments_1_time_for_1_bill,
  ADJUST_BILL_CAN_NOT_ADJUST: language.error.unable_to_adjust_for_this_voucher,
  BILL_CREATED_BEFORE_LOCK_DATE: language.error.can_not_cancel_bills_created_before_lock_date,

  // Payment
  RECEIPT_CREATE_MULTI_ERROR: language.error.payment_of_many_apartments_failed,

  TOTAL_PAYMENT_BILL_ADJUST_DOWN_OVER_UNIT_ACCOUNT_BALANCE: language.error.the_payment_for_the_adjustment_bill_exceeds_the_flat_account,
  FIELD_IS_REQUIRED: language.error.the_input_contains_invalid_keywords,

  // Amenities Booking
  CAN_NOT_PAY_BECAUSE_THIS_AMENITY_BOOKING_IS_NOT_PENDING:
    language.error.cannot_pay_for_this_amenity_because_it_is_not_pending_or_waiting_for_complete,
  CAN_NOT_REFUND_BECAUSE_THIS_AMENITY_BOOKING_IS_NOT_WAITING_FOR_CANCELLED_OR_COMPLETED: language.error.amenities_booking_payment_error_1,
  AMENTITY_BOOKING_HAS_ALREADY_BEEN_REFUNDED: language.error.amenities_booking_payment_error_2,
  CANNOT_REFUND_ZERO_MONEY: language.error.amenities_booking_payment_error_3,
  AMENITY_BOOKING_PAY_AFTER_END_DATE_USAGE: language.error.utility_bills_cannot_be_paid_with_a_usage_date,

  // Template
  TEMPLATE_NOT_FOUND: language.template_has_not_been_set_up,

  // card
  CARD_CODE_UNIQUE: language.card_code_existed,
  CARD_CAN_NOT_UPDATE: language.card_can_not_update,

  // asset
  ASSET_INVALID_PLACE_TYPE: language.asset_invalid_place_type,
  ASSET_STATUS_VALIDATE: language.asset_invalid_status,
  ASSET_INVALID_LOCATION: language.asset_invalid_location,
  ASSET_INVALID_DEPARTMENT: language.asset_invalid_manager_unit,
  ASSET_INVALID_SUPPLIER: language.asset_invalid_provider,
  ASSET_INVALID_MAINTENANCE_UNIT: language.asset_invalid_maintenance_unit,

  // partner
  PARTNER_COMPANY_NAME_UNIQUE: language.partner_company_name_unique,

  // supply
  SUPPLY_INVALID_PARTNER: language.supply_invalid_partner,
  SUPPLY_INVALID_DEPARTMENT: language.supply_invalid_department,
  SUPPLY_INVALID_EMPLOYEE: language.supply_invalid_employee,

  // inventory transfer management
  ELEVATOR_RESERVATION_INACTIVE: language.inventory_transfer_management_inactive,

  // access management
  VISITOR_INACTIVE: language.access_management_inactive,

  // Parking
  CONTRACT_REGISTRATION_PLATE_UNIQUE: language.contract_registration_plate_unique,
  CONTRACT_REGISTRATION_PLATE_RAW_UNIQUE: language.contract_registration_plate_unique,
  VEHICLE_ALREADY_INTEGRATED_WITH_CARD: language.vehicle_already_integrated_with_card,
  REGISTRATION_PLATE_UNIQUE: language.registration_plate_unique,

  // Card
  CARD_ALREADY_INTEGRATED: language.card_already_integrated,

  // tariff template
  CONTRACTTEMPLATE_NAME_UNIQUE: language.tariff_template_name_unique,

  // request
  REQUEST_CANCELLED_FAIL: language.request_change_progress_cancel_failure,

  UNIT_GROUP_PAYMENT_CONFIG_NOT_FOUND: language.unit_group_payment_config_not_found,
  UTILITY_GROUP_CODE_EXIST: language.utility_group_code_unique,

  // Bill manual
  BILL_MISSING_UNIT: language.apartment_not_found,
  BILL_MISSING_TYPE: language.bill_type_invalid,
  BILL_MISSING_SERVICE: language.service_not_found,
  BILL_MISSING_NUMBER_USE: language.number_use_invalid,
  BILL_MISSING_INCURRED_CREATED_FOR: language.fee_notification_month_invalid,
  BILL_MISSING_TOTAL_PAYMENT: language.total_payment_invalid,
  BILL_MISSING_START_DATE: language.start_date_bill_invalid,
  BILL_MISSING_END_DATE: language.end_date_bill_invalid,
  BILL_MISSING_OLE_INDEX: language.old_index_invalid,
  BILL_MISSING_NEW_INDEX: language.new_index_invalid,
  BILL_ALREADY_EXISTS_FOR_THE_MONTH: language.bill_already_exists_for_the_month,
  BILL_INVALID_TOTAL_PAYMENT: language.total_payment_invalid,
  STATUS_CAN_NOT_CHANGE: language.status_can_not_change,
  DEPOSIT_STATUS_CAN_NOT_CHANGE: language.deposit_status_can_not_change,

  REQUIRED_DEPOSIT: language.require_deposit,
  REQUIRED_REFUND: language.require_refund,

  // company
  TAX_CODE_EXISTED: language.tax_code_existed,
  COMPANY_HAS_CONTRACT: language.company_has_contract,

  // business contract
  CONTRACT_NO_EXISTED: language.contract_no_existed,
  LIMIT_REACHED: language.limit_reached,

  // Apartment account
  UNIT_ACCOUNT_CAN_NOT_IMPORT: language.unit_account_can_not_import,
  UNIT_NOT_FOUND: language.unit_not_found,
  UNIT_CAN_NOT_EMPTY: language.unit_can_not_empty,
  UNIT_ACCOUNT_FIELD_MISSING: language.unit_account_field_missing,
  UNIT_ACCOUNT_INDEX_INVALID: language.unit_account_index_invalid,
  UNIT_ACCOUNT_BALANCE_INVALID: language.unit_account_balance_invalid,
  UNIT_CAN_NOT_DUPLICATE: language.unit_can_not_duplicate,

  // Asset
  ASSET_INVALID_LAST_MAINTENANCE: language.asset_invalid_last_maintenance,
  ASSET_INVALID_CYCLE_MAINTENANCE: language.asset_invalid_cycle_maintenance,
  ASSET_INVALID_NEXT_MAINTENANCE_DATE: language.asset_invalid_next_maintenance_date,
  ASSET_INVALID_EMPLOYEE: language.asset_invalid_employee,
  ASSET_CODE_EXISTED: language.asset_code_existed,
  ASSET_INVALID_DATA: language.asset_invalid_data,

  // Supplies
  SUPPLY_INVALID_STATUS: language.supply_invalid_status,
  SUPPLY_EXISTED: language.supply_existed,
  SUPPLY_CODE_EXISTED: language.supply_code_existed,
  SUPPLY_CODE_REQUIRED: language.supply_code_required,
  SUPPLY_WARE_HOUSING_AMOUNT_INVALID: language.supply_ware_housing_amount_invalid,
  SUPPLY_LIMIT_INVALID: language.supply_limit_invalid,
  SUPPLY_INVALID_QUANTITY: language.supply_invalid_quantity,
  SUPPLY_INVALID_DATA: language.supply_invalid_data,
  SUPPLY_TOTAL_AMOUNT_INVALID: language.supply_total_amount_invalid,
  SUPPLY_DATE_IMPORT_WAREHOUSE_INVALID: language.supply_date_import_warehouse_invalid,

  // Device
  METER_NOT_FOUND: language.meter_not_found,
  METER_NAME_EXISTS: language.meter_name_exists,
  METER_HAS_CONSUMPTION: language.meter_has_consumption,
  METER_NAME_INVALID: language.meter_name_invalid,
  CONTRACT_TEMPLATE_NAME_INVALID: language.contract_template_name_invalid,
  UNIT_NAME_INVALID: language.unit_name_invalid,
  SERVICE_NAME_INVALID: language.service_name_invalid,
  METER_NAME_EXISTS_IN_UNIT: language.meter_name_exists_in_unit,
  CONTRACT_TEMPLATE_HAS_METER: language.contract_template_has_meter,

  // Consumption
  CONSUMPTION_CURRENT_INDEX_INVALID: language.consumption_current_index_invalid,
  CONSUMPTION_METER_INVALID: language.consumption_meter_invalid,
  CONSUMPTION_NOT_FOUND: language.consumption_not_found,
  CONSUMPTION_CAN_NOT_CREATE: language.consumption_can_not_create,
  CONSUMPTION_HAS_CREATED_IN_MONTH: language.consumption_has_created_in_month,

  // Group system
  GROUP_SYSTEM_NOT_FOUND: language.group_system_not_found,
  GROUP_SYSTEM_INVALID_NAME: language.group_system_invalid_name,
  GROUP_SYSTEM_NAME_EXISTED: language.group_system_name_existed,
  GROUP_SYSTEM_HAS_SYSTEM: language.group_system_has_system,

  // System
  SYSTEM_NOT_FOUND: language.system_not_found,
  system_invalid_name: language.system_invalid_name,
  system_invalid_group_system_id: language.system_invalid_group_system_id,
  SYSTEM_NAME_EXISTED: language.system_name_existed,
  SYSTEM_HAS_MAINTENANCE_SCHEDULE: language.system_has_maintenance_schedule,

  // Card registration
  CARD_REGISTRATION_NOT_FOUND: language.card_registration_not_found,
  CARD_REGISTRATION_INACTIVE: language.card_registration_inactive,
  METER_NAME_NOT_EXIST_IN_UNIT: language.meter_name_not_exist_in_unit,
  CONSUMPTION_CURRENT_INDEX_NO_LESS_THAN_PREVIOUS_MONTHS: language.consumption_current_index_no_less_than_previous_months,
  CONSUMPTION_CURRENT_INDEX_NO_GREATER_THAN_FOLLOWING_MONTHS: language.consumption_current_index_no_greater_than_following_months,

  // Maintenance Schedule
  INTERVAL_INVALID: language.interval_invalid,
  START_DATE_INVALID: language.start_date_invalid,
  END_DATE_INVALID: language.end_date_invalid,
  REPEAT_TYPE_INVALID: language.repeat_type_invalid,
  WEEKDAY_INVALID: language.weekday_invalid,
  DAY_OF_MONTH_INVALID: language.day_of_month_invalid,
  MAINTENANCE_SCHEDULE_NOT_FOUND: language.maintenance_schedule_not_found,
  START_DATE_BEFORE_CURRENT_DATE: language.start_date_before_current_date,
  // Contract Consumption
  CONTRACT_FACTOR_INVALID: language.contract_factor_invalid,
  CONTRACT_NUMBER_PERSON_QUOTA_INVALID: language.contract_number_person_quota_invalid,
  CONTRACT_FIELD_INVALID: language.contract_field_invalid,
  CONTRACT_NOT_FOUND_IN_CREATED_FOR: language.contract_not_found_in_created_for,
  WAREHOUSE_INBOUND_CODE_REQUIRED: language.warehouse_inbound_code_required,

  // Billing
  INVOICE_MISSING_ID: language.error.invoice_missing_id,
  INVOICE_NOT_FOUND: language.error.invoice_not_found,
  INVOICE_NOT_HAVE_ITEMS: language.error.invoice_not_have_items,
  INVOICE_PROVIDER_NOT_VALID: language.error.invoice_provider_not_valid,
  INVOICE_SELLER_NOT_FOUND: language.error.invoice_seller_not_found,
  INVOICE_BUYER_NOT_FOUND: language.error.invoice_buyer_not_found,
  INVOICE_ORIGIN_INVOICE_NOT_FOUND: language.error.invoice_origin_invoice_not_found,
  INVOICE_ORIGIN_INVOICE_NOT_HAVE_TAX_AUTHORITY_STATUS_SUCCESS: language.error.invoice_origin_invoice_not_have_tax_authority_status_success,
  INVOICE_VALID_INPUT_INVALID_BUYER_TAX_CODE: language.error.invoice_valid_input_invalid_buyer_tax_code,
  TAX_CODE_INVALID: language.error.tax_code_invalid,
  IVI_REQUIRED_BUYER_ADDRESS: language.error.invoice_required_buyer_address,
  BUYER_ADDRESS_REQUIRED_WHEN_TAXCODE: language.error.buyer_address_required_when_taxcode,
  BUYER_BUDGET_CODE_LENGTH: language.error.buyer_budget_code_length,
  INVOICE_NULL: language.error.invoice_null,
  RECEIPT_HAS_BEEN_SYNC: language.error.receipt_has_been_sync,
  INVOICE_PUBLISHED_CANNOT_PREVIEW: language.error.invoice_published_cannot_preview,
  INVOICE_PARTNER_STATUS_PUBLISHED: language.error.invoice_signed_cannot_delete,
  INVOICE_PARTNER_STATUS_CHECK_FAILED: language.error.invoice_partner_status_check_failed,
  PROVIDER_NOT_FOUND: language.error.provider_not_found,
  INVOICE_BUYER_ID_INVALID_FORMAT: language.error.invoice_buyer_id_invalid_format,
  INVOICE_CANNOT_UPDATE_BUYER_INFO: language.error.invoice_cannot_update_buyer_info,
};

export default RESPONSE_MAPPING;
